module.exports = __webpack_public_path__ + "static/img/10.3ced51b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/sp/10.png
// module id = RO9v
// module chunks = 0